import React, { PureComponent } from 'react'
import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import { FormTxt } from 'atoms/Inputs'
import {
  MainWrapper,
  ModalHead,
  ModalFooter,
  LevelRowContainer,
  InputRow,
} from './styles'
import { withTheme } from 'styled-components'
import FormSelect from 'components/atoms/Inputs/FormSelect'
import FormChips from 'components/atoms/Inputs/FormChips'
import DataTable from '../DataTable/index'
import { actionFormatter, checkFormatter, selectFormatter } from 'components/molecules/TableFormatters'
import { NewCompanyContractor } from 'fixtures/TemplateData'
import lo from 'lodash';

export class NewCompanyModal extends PureComponent {
  isEditingMode() {
    const { companyData } = this.props
    return companyData.hasOwnProperty('createdAt') ? true : false
  }

  onChangeContractor(val, row, field, rowIndex) {
    const { fnChange, companyData } = this.props
    const existing = companyData.contractors.map(d => d.id).filter(d => d !== '-')
    if (existing.indexOf(val) > -1){
      return alert('Please choose another contractor')
    }
    const newData = companyData.contractors.map((d,i) => i === rowIndex ? {
      ...row,
      [field] : val
    } : d)
    fnChange(newData, 'contractors')
  }

  switchCheck(row, field, rowIndex) {
    const { fnChange, companyData } = this.props
    const newData = companyData.contractors.map((d,i) => i === rowIndex ? {
      ...row,
      CompanyContractor: {
        isActive: !row.CompanyContractor.isActive
      }
    } : d)
    fnChange(newData, 'contractors')
  }

  addContractor() {
    const { fnChange, companyData } = this.props
    const newData = [...companyData.contractors, lo.cloneDeep(NewCompanyContractor)]
    fnChange(newData, 'contractors')
  }

  onDeleteContractor(row, rowIndex) {
    const { fnChange, companyData } = this.props
    const newData = companyData.contractors.filter((d,i) => i !== rowIndex)
    fnChange(newData, 'contractors')
  }

  render() {
    const { theme, companyData, deptsList = [], contractorsList = [], workLocationsList = [], isDisabled, fnChange, isMobileView } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
      marginBottom: '16px'
    }
    const contractorConfig = [
      {
        dataField: 'id',
        text: 'Contractors',
        formatter: selectFormatter,
        formatExtraData: {
          placeholder: 'Select Contractor',
          options: contractorsList,
          field: 'id',
          valField: 'id',
          fn: (val, row, field, rowIndex) => this.onChangeContractor(val, row, field, rowIndex),
          allowEdit: true,
        },
        headerAttrs: { width: isMobileView ? 150 : 200 },
        sort: true
      },
      {
        dataField: 'CompanyContractor.isActive',
        text: 'Active',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: true,
          field: 'CompanyContractor',
          subField: 'isActive',
          fn: (row, field, rowIndex) => this.switchCheck.bind(this, row, field, rowIndex)
        },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 80 : 100 },
        formatter: actionFormatter,
        formatExtraData: {
          allowDel: true,
          del: (row, rowIndex) => this.onDeleteContractor.bind(this, row, rowIndex),
        },
        isDummyField: true
      }
    ]

    return (
      <MainWrapper>
        <ModalHead>
          <Label lineheight={'29px'} size={'24px'} mb={'0px'}>
            {this.isEditingMode() ? 'Edit ' : 'Add New '} Company
          </Label>
        </ModalHead>
        <LevelRowContainer>
          <InputRow>
            <Label lineheight={'14px'} size={'12px'}>
              Name
            </Label>
            <FormTxt
              placeholder={'Enter company name'}
              mb={'16px'}
              value={companyData.name}
              onChangeVal={e => fnChange(e.target.value, 'name')}
              {...inputConfig}
            />
            <Label lineheight={'14px'} size={'12px'}>
              Code
            </Label>
            <FormTxt
              placeholder={'Enter company code'}
              mb={'16px'}
              value={companyData.code}
              onChangeVal={e => fnChange(e.target.value, 'code')}
              {...inputConfig}
            />
            <div className="mb-3">
              <Label lineheight={'14px'} size={'12px'}>
                Work Location
              </Label>
              <FormSelect
                placeholder={'Select Work Location'}
                onChangeVal={e => fnChange(e.target.value, 'workLocationId')}
                options={workLocationsList}
                value={companyData.workLocationId}
                valField={'id'}
                dispField={'name'}
                arrowSize={'5%'}
                {...inputConfig}
              />
            </div>
            <div className="mb-3">
              <Label lineheight={'14px'} size={'12px'}>
                Department
              </Label>
              <FormChips
                placeholder={'Select Department'}
                onChangeVal={e => fnChange(e, 'departments')}
                options={deptsList}
                control={companyData.departments}
                dispField={'nameDisplay'}
                {...inputConfig}
              />
            </div>
            <div className="mb-3">
              <Label lineheight={'14px'} size={'12px'}>
                Contractor
              </Label>
              <DataTable
                leftSlot={
                  <ButtonReg
                    btnTxt={'Add'}
                    disabled={companyData.contractors && companyData.contractors.findIndex(d => d.id === '-') > -1}
                    onClick={() => this.addContractor()}
                    width={'78px'}
                  />
                }
                allowSearch={false}
                rightSlotAlt={true}
                defaultSize={100}
                isMobile={isMobileView}
                dataList={companyData.contractors || []}
                columnConfig={contractorConfig}
              />
            </div>
          </InputRow>
        </LevelRowContainer>
        <ModalFooter>
          <ButtonReg onClick={this.props.fnSwitch} disabled={isDisabled} transparent btnTxt={'Cancel'} />
          <ButtonReg onClick={this.props.fnSubmit} disabled={isDisabled} btnTxt={isDisabled ? 'Submitting...' : 'Submit'} />
        </ModalFooter>

      </MainWrapper>
    )
  }
}

export default withTheme(NewCompanyModal)
